module.exports = __webpack_public_path__ + "img/up6.10a5ac61.png";